export default __webpack_public_path__ + "static/everly-e0a81c0a122b6f7facbee1e1421208dc.jpg";